export default __webpack_public_path__ + "static/media/giide-illo-08.b0a72de5.png";